import { render, staticRenderFns } from "./AssignForm.vue?vue&type=template&id=69370988&scoped=true&"
import script from "./AssignForm.vue?vue&type=script&lang=ts&"
export * from "./AssignForm.vue?vue&type=script&lang=ts&"
import style0 from "./AssignForm.vue?vue&type=style&index=0&id=69370988&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69370988",
  null
  
)

export default component.exports